import { useRouteMatch } from "react-router-dom";

export function usePathApplication() { 
    let { path } = useRouteMatch();
    const application = path.split('/')[1];
    return { application }
}
